import { ChartOptions } from 'chart.js';
import { Context } from 'chartjs-plugin-datalabels';

export interface ChartProps {
  chartData: number[];
  chartWidth: number;
}

export const COLUMN_WIDTH = 60;
export const DEFAULT_HORIZONTAL_PADDING = -10;
export function getChartWidth(nbCol: number) {
  return COLUMN_WIDTH * nbCol;
}

export const chartOptions = ({
  labelOffset,
  horizontalPadding = DEFAULT_HORIZONTAL_PADDING,
  bottomPadding = 0,
  iconUnicode,
  beginAtZero = false,
}: {
  labelOffset: number;
  horizontalPadding?: number;
  bottomPadding?: number;
  iconUnicode?: string;
  beginAtZero?: boolean;
}): ChartOptions | { plugins: { datalabels: any } } => ({
  elements: {
    line: {
      tension: 0,
    },
  },
  layout: {
    padding: {
      bottom: bottomPadding,
      left: horizontalPadding,
      right: horizontalPadding + 10,
      top: 30 + bottomPadding,
    },
  },
  legend: {
    display: false,
  },
  maintainAspectRatio: false,
  plugins: {
    datalabels: {
      labels: {
        // Do not delete : to use in case we want to display icon in the rain chart (don't forget to set back fontello in _document as well)
        icon: iconUnicode
          ? {
              color: 'white',
              font: { family: 'fontello', size: 25, style: 'normal' },
              formatter: (value: number, context: Context) => {
                const maxValue = context.dataset.data
                  ? (context.dataset.data as number[]).reduce((max: number, v: number) => (v > max ? v : max), 0)
                  : 0;
                return value >= (1 / 3) * maxValue ? iconUnicode : '';
              },
            }
          : undefined,
        value: {
          align: 'end',
          anchor: 'end',
          font: { family: 'Montserrat', size: 14, style: 600 },
          formatter: (_: never, context: Context) => (context.chart.data.labels as string[])[context.dataIndex],
          offset: labelOffset,
        },
      },
    },
  },
  responsive: false,
  scales: {
    xAxes: [
      {
        display: false,
      },
    ],
    yAxes: [
      {
        gridLines: {
          display: false,
        },
        ticks: {
          beginAtZero,
          display: false,
        },
      },
    ],
  },
  tooltips: {
    enabled: false,
  },
});
